import { Link } from 'react-router-dom';
import styled from 'styled-components';

const StyledCard = styled.div`
  border-radius: 8px;
  box-shadow: 0 1px 6px 0 rgb(0 0 0 / 6%);
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
  .user-card-top {
    padding: 20px 0;
    text-align: center;
    .user-number {
      font-size: 32px;
      font-weight: bold;
    }
  }
  .user-card-bottom {
    width: 100%;
    padding: 10px 0;
  }
`;

function SettingCard({ title, number, path, color }) {
  return (
    <div className="col-sm-4">
      <Link to={path}>
        <StyledCard className="card user-card">
          <div className="user-card-top">
            <h2 className={`user-number text-${color}`} style={{ color: color }}>
              {number}
            </h2>
          </div>
          <div className={`user-card-bottom bg-${color}`} style={{ backgroundColor: color }}>
            <h5 className="user-title text-center text-white">{title}</h5>
          </div>
        </StyledCard>
      </Link>
    </div>
  );
}

export default SettingCard;
